import './App.css'
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from './components/Home.jsx';
import Practice from './components/Practice.jsx';
import EndlessPractice from './components/EndlessPractice.jsx';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/test" element={<Practice />}/>
        <Route path="/endless" element={<EndlessPractice />}/>
        {/* catch-all: redirect to Home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;